// @ts-nocheck
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import React, { createContext, useEffect, useState } from "react";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import CenturionAnniversary from "./component/CenturionAnniversary";
import ChangePassword from "./component/client/ChangePassword";
import ClientAuthProvider from "./component/client/ClientAuthProvider";
import ClientPage from "./component/client/ClientPage";
import ForgotPassword from "./component/client/ForgotPassword";
import ResetPassword from "./component/client/ResetPassword";
import SignIn from "./component/client/SignIn";
import SignUp from "./component/client/SignUp";
import Clinics from "./component/clinics/Clinics";
import Conference from "./component/Conference";
import Doctors from "./component/doctors/Doctors";
import Event from "./component/event/Event";
import EventRegister from "./component/event/EventRegister";
import Events from "./component/event/Events";
import Examination from "./component/exam/Exam";
import Gallery from "./component/Gallery";
import JournalCategories from "./component/journal/JournalCategories";
import JournalList from "./component/journal/JournalList";
import JournalReader from "./component/journal/JournalReader";
import Layout from "./component/Layout";
import LegalDocsList from "./component/legal-docs/LegalDocList";
import LegalReader from "./component/legal-docs/LegalDocReader";
import Book from "./component/library/Book";
import ChapterReader from "./component/library/ChapterReader";
import Library from "./component/library/Library";
import { Main } from "./component/Main";
import Meeting from "./component/meetings/Meeting";
import MeetingRegister from "./component/meetings/MeetingRegister";
import PastMeeting from "./component/meetings/PastMeeting";
import NotFound from "./component/NotFound";
import Payment from "./component/payment/Payment";
import Post from "./component/post/Post";
import PostList from "./component/post/PostList";
import PricingTable from "./component/PricingTable/PricingTable";
import StandardList from "./component/standards/StandardList";
import StandardReader from "./component/standards/StandardReader";
import MockTest from "./component/study/MockTest";
import MockTestList from "./component/study/MockTestList";
import Terms from "./component/Terms";
import Training from "./component/training/Training";
import TrainingList from "./component/training/TrainingList";
import ClientAuthContext from "./context/ClientAuthContext";
import data from "./data/data.json";

export const ThemeContext = createContext(null);

function App() {
  window.$ = window.jQuery = require("jquery");
  // EN - true, MN - false
  const [language, setLanguage] = useState(false);
  const [theme, setTheme] = useState([
    data.Theme.ThemeColor.colorOne,
    data.Theme.ThemeColor.colorTwo,
  ]);
  const [userData, setUserData] = useState({});

  useEffect(() => {
    let msid_app_lang = localStorage.getItem("msid_app_lang");
    if (msid_app_lang) {
      if (msid_app_lang === "MN") {
        setLanguage(false);
      } else {
        setLanguage(true);
      }
    } else {
      fetchCountryCode();
    }
  }, []);

  const fetchCountryCode = async () => {
    try {
      const response = await fetch("https://ipapi.co/json/");
      const data = await response.json();
      if (data.country_code === "MN") {
        setLanguage(false);
        localStorage.setItem("msid_app_lang", "MN");
      } else {
        setLanguage(true);
        localStorage.setItem("msid_app_lang", "EN");
      }
    } catch (error) {
      console.error("Error fetching the country code:", error);
    }
  };

  return (
    <ThemeContext.Provider value={{ language, setLanguage, theme, setTheme }}>
      <ClientAuthContext.Provider value={{userData, setUserData}}>
      <BrowserRouter>
        <Routes>
          <Route path='/' element={<Layout data={data} language={language} />}>
            <Route path='/' element={<ClientAuthProvider />}>
              <Route index path='/' element={<Main data={data} language={language} />}/>
              <Route path='/client' element={<ClientPage data={language ? {...data.English.Client, ...data.English.SignUp} : {...data.Mongolian.Client, ...data.Mongolian.SignUp}}/>}/>
              <Route path="/client/signin" element={<SignIn data={language ? data.English.SignIn : data.Mongolian.SignIn} language={language}/>}/>
              <Route path='/training/:id' element={<Training data={language ? data.English.Training : data.Mongolian.Training}/>}/>
              <Route path='/book/:id' element={<Book data={language ? data.English.Library : data.Mongolian.Library}/>}/>
              <Route path='/chapter/:id' element={<ChapterReader data={language ? data.English.Library : data.Mongolian.Library}/>}/>
              <Route path="/change-password" element={<ChangePassword data={language ? data.English.SignUp : data.Mongolian.SignUp}/> }/>
              <Route path='journal/:id' element={<JournalReader data={language ? data.English.Journals : data.Mongolian.Journals}/>}/>
              <Route path='legal-document/:id' element={<LegalReader data={language ? data.English.LegalDocs : data.Mongolian.LegalDocs}/>}/>
              <Route path='standard/:id' element={<StandardReader data={language ? data.English.Standard : data.Mongolian.Standard}/>}/>
              <Route path='event/:id' element={<Event data={language ? data.English.Events : data.Mongolian.Events} language={language}/>}/>
              <Route path='event/:id/register' element={<EventRegister data={language ? data.English.EventRegister : data.Mongolian.EventRegister} language={language}/>}/>
              <Route path='/client/payment/:id' element={
                <Payment data={language ? data.English.Payment : data.Mongolian.Payment} priceData={language ? data.English.Price : data.Mongolian.Price} language={language}/>}
              />
              <Route path='/events' element={
                <Events data={language ? data.English.Events : data.Mongolian.Events} language={language}/>}
              />
              <Route path="/event/register" element={<EventRegister data={language ? data.English.EventRegister : data.Mongolian.EventRegister} language={language}/>}/>
              <Route path="/signup" element={
                <SignUp data={language ? data.English.SignUp : data.Mongolian.SignUp}/>}
              />
              <Route path="/forgot-password" element={
                <ForgotPassword data={language ? data.English.SignIn : data.Mongolian.SignIn}/> }
              />
              <Route path="/reset-password" element={
                <ResetPassword data={language ? data.English.SignUp : data.Mongolian.SignUp}/> }
              />
              <Route path='/membership' element={
                <PricingTable data={language ? data.English.Price : data.Mongolian.Price} language={language} />}
              />
              <Route path='/training' element={<TrainingList data={language ? data.English.Training : data.Mongolian.Training}/>}/>
              <Route path='/tests' element={<MockTestList data={language ? data.English.MockTests : data.Mongolian.MockTests}/>}/>
              <Route path='/tests/:id' element={<MockTest data={language ? data.English.MockTests : data.Mongolian.MockTests}/>}/>
              <Route path='/library' element={<Library data={language ? data.English.Library : data.Mongolian.Library}/>}/>
              <Route path='/conference' element={<Conference data={language ? data.English.Conference : data.Mongolian.Conference} />} />
              <Route path='/100-anniversary' element={
                <CenturionAnniversary
                  data={language ? data.English.CenturionAnniversary : data.Mongolian.CenturionAnniversary}
                  centurion={language ? data.English.Home.centurion : data.Mongolian.Home.centurion}
                  language={language}
                />}
              />
              <Route path='/annual-meetings' element={
                <Meeting data={language ? data.English.AnnualMeetings : data.Mongolian.AnnualMeetings} language={language}/>}
              />
              <Route path='/annual-meeting/:id' element={
                <PastMeeting data={language ? data.English.AnnualMeetings : data.Mongolian.AnnualMeetings} language={language}/>}
              />
              <Route path="/meeting/register" element={<MeetingRegister data={language ? data.English.SignUp : data.Mongolian.SignUp} language={language}/>}/>
              <Route path='clinics' element={
                <Clinics data={language ? data.English.Clinics : data.Mongolian.Clinics} language={language ? "en" : "mn"} />}
              />
              <Route path='doctors' element={
                <Doctors data={language ? data.English.Doctors : data.Mongolian.Doctors} language={language ? "en" : "mn"} />}
              />
              <Route path='gallery' element={<Gallery data={language ? data.English.Gallery : data.Mongolian.Gallery} />}/>
              <Route path='posts' element={<PostList data={language ? data.English.Posts : data.Mongolian.Posts} />}/>
              <Route path='posts/:id' element={<Post data={language ? data.English.Posts : data.Mongolian.Posts}/>}/>
              <Route path='journal-categories' element={<JournalCategories data={language ? data.English.Journals : data.Mongolian.Journals} language={language ? "en" : "mn"}/>}/>
              <Route path='journals/:tab' element={<JournalList data={language ? data.English.Journals : data.Mongolian.Journals} language={language ? "en" : "mn"}/>}/>
              <Route path='legal-documents' element={<LegalDocsList data={language ? data.English.LegalDocs : data.Mongolian.LegalDocs} language={language ? "en" : "mn"}/>}/>
              <Route path='standards' element={<StandardList data={language ? data.English.Standard : data.Mongolian.Standard} language={language ? "en" : "mn"}/>}/>
              <Route path='/examination' element={<Examination data={language ? data.English.Exam : data.Mongolian.Exam}/>} />
              <Route path='/examination/:tab' element={<Examination data={language ? data.English.Exam : data.Mongolian.Exam}/>} />
              <Route path='/terms' element={<Terms language={language ? "en" : "mn"} />} />
              <Route path='*' element={<NotFound />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
      </ClientAuthContext.Provider>
    </ThemeContext.Provider>
  );
}
export default App;
